export function initOptionalFiles() : void {
    document.querySelectorAll<HTMLElement>('.js-optional-files').forEach($optionalFiles => {
        new OptionalFiles($optionalFiles);
    });
}

export class OptionalFiles {
    $container: HTMLElement;
    $addButton: HTMLButtonElement|null;
    $inputs: NodeListOf<HTMLInputElement>;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$addButton = this.$container.querySelector<HTMLButtonElement>('.js-optional-files-add');
        this.$inputs = this.$container.querySelectorAll<HTMLInputElement>('.js-optional-files-input');
        this.$addButton?.addEventListener('click', () => this.addInput());
    }

    /**
     * Event when the $addButton is clicked
     */
    addInput() {
        const $displayableInputs = Array.prototype.filter.call(this.$inputs, $input => $input.classList.contains('hidden'));

        if ($displayableInputs.length > 0) {
            $displayableInputs[0].classList.remove('hidden');
        }

        if ($displayableInputs.length <= 1) {
            this.$addButton?.classList.add('hidden');
        }
    }
}
